export default {
  0: "企業の発展に伴い、さまざまなシナリオでの複雑な人事管理やユーザーのアクセス行動は、企業のネットワークに潜在的な脅威をもたらすことになる。 システムへのアクセス行動や従業員のアカウント状況をタイムリーかつ効果的に監視できるかどうかは、企業のビジネスセキュリティに大きな影響を与える。 さらに、ログイン情報の記録を怠り、アイデンティティ管理を無視したセキュリティ監査もシステムのセキュリティを脅かすことになり、ログインの異常やアクセスや他の現象への違法な権限は、対処するためのタイムリーな方法で見つけることができない;アカウントの特権を付与されたプロセスを把握することはできなくて、事故をトレースすることもできない。 同時に、手動監査は効率が悪く、エラーが出やすい。",
  1: "ユーザー行動監査：時間、訪問者、場所（IP アドレス、マシン番号）、アプリケーション、ログインが成功したかどうかなど、すべてのユーザーの訪問を記録します。",
  2: "管理者行動監査：管理者アカウントの権限付与操作を記録します。",
  3: "アプリケーション アクセス 状況：企業が各アプリケーションの実際のアクセス状況を把握し、ソフトウェアの使用価値を判断し、IT 投資コストを最適化するのに役立ちます。",
  4: "Authing スマートプラットフォームは、不審なログインや異常行動がないかユーザーを監視し、状況に応じて自動的にマルチシルバー認証を有効化し、セキュリティを大幅に向上させます。",
  5: "担当者・部署別のオープンニングのカスタマイズ対応",
  6: "強力なパスワードポリシーが成功するかどうかのカスタマイズをサポートしています。",
  7: "人（グループ）ごとに異なるパスワードポリシーを設定します。",
  8: "エンタープライズグレードの SaaS サービスと企業にとって最も重要なアイデンティティサービスを提供するプロバイダとして、Authing は常に次のことを行ってきました。 Authing は、国際的な権威のあるセキュリティ認証と成熟した情報セキュリティ管理システムを持っており、完全なソフトウェア開発に強いコミットメント、信頼性の高いデータセキュリティと24 時間365 日のセキュリティ緊急対応によるライフサイクルセキュリティを持っています。",
  9: "データストレージは AES-256アルゴリズムを使用して暗号化されています。<br /> データは SSL/TLS プロトコルで暗号化されて送信され、2048ビットの RSA 鍵<br /> は KMS 管理鍵を使用し、鍵は定期的にローテーションされており、1つの暗号でも高いセキュリティを確保しています。<br /> アカウントログインの多要素認証 <br /> 詳細なデータアクセスと操作ログの監査<br /> クライアントデータのセキュリティポリシー管理<br /> 高いデータ可用性、マルチコピー冗長化ストレージ、定期的なフルバックアップ<br /> は、データの可用性、整合性とデータセキュリティを保証します。<br /> 総合的なセキュリティ防御",
  10: "Authing は中国サイバーセキュリティ産業白書に含まれている",
  11: " Authing の立ち上げ当初は、中国情報通信技術研究院（CIIT）の「中国におけるアイデンティティ管理・アクセス制御分野の革新的企業」に選ばれ、「2019年サイバーセキュリティ業界白書」にも掲載されています。",
  12: "ISO/IEC 27001:2013 情報セキュリティマネジメントシステム ISO 27001 は、情報セキュリティマネジメントシステムに関する規格で、業界から表彰されています。 広く認められたセキュリティマネジメントシステム規格で、国際的に権威のある厳格な情報セキュリティシステム認証基準とされており Authing のデータセンター、管理システム、研究開発、機能部門がこの認証を取得しているので、情報セキュリティマネジメントの分野では、国際基準に沿った十分な情報セキュリティリスクの特定と管理能力を有しており、グローバルな情報セキュリティマネジメントシステムを提供することができます。 お客様に安心・安全なサービスを提供しています。",
  13: "Authing の認証は、プライバシーコンプライアンスシステムの構築に長年取り組んできた実績と、Authing のセキュリティチームがユーザーのプライベートデータのセキュリティを保護し、ユーザーに透明性があり、効率的で安全で信頼性の高いサービスを提供していることを証明するものです。",
  14: "公安情報セキュリティレベル3認証 GB/T 22239-2008情報セキュリティ技術情報システムのセキュリティレベル保護の基本要求事項」は、中華人民共和国標準化局が発行する情報セキュリティ規格です。 レベルは情報システムの重要度に応じて低から高まで1から5レベルに分けられ、セキュリティレベルによって異なる保護戦略を実施し の要件を満たしています。Authing は、専門的な評価機関によって評価されたレベル3の情報システム保護戦略を採用しています。 当社は、物理的、ネットワーク、ホスト、アプリケーション、およびデータの観点から、当局に認められたセキュリティ保護機能を有していることを意味します。 そして、それは業界でも高いレベルに達しています。",
  15: " 7x24時間セキュリティ緊急対応<br /> 災害時の迅速な復旧を実現するために、2箇所に3拠点のバックアップを設置し、<br /> 一貫したサービスを提供します。",
  16: "統一されたアイデンティティ・プラットフォームのリスクポイント - 原理とは？",
  "security-banner-subtitle":
    "Authingは異なる国と業界のコンプライアンス要求に従い、お客様の信頼できるサービスを全力で構築する。同時に、業界の安全基準の制定と普及に積極的に参与し、コンプライアンスすなわちサービスを堅持し、安全で信頼できるクラウド生態環境を建設し、運行する。",
  "security-strategy-item-1": "データストレージは AES-256アルゴリズムを使用して暗号化されています",
  "security-strategy-item-2": "データは SSL/TLS プロトコルで暗号化されて送信され、2048ビットの RSA 鍵",
  "security-strategy-item-3":
    "は KMS 管理鍵を使用し、鍵は定期的にローテーションされており、1つの暗号でも高いセキュリティを確保しています。",
  "security-strategy-item-4": "アカウントログインの多要素認証 ",
  "security-strategy-item-5": "詳細なデータアクセスと操作ログの監査",
  "security-strategy-item-6": "クライアントデータのセキュリティポリシー管理",
  "security-strategy-item-7": "高いデータ可用性、マルチコピー冗長化ストレージ、定期的なフルバックアップ",
  "security-strategy-item-8": "は、データの可用性、整合性とデータセキュリティを保証します",
  "security-strategy-item-9": "総合的なセキュリティ防御",
  Authing安全与合规: "Authing セキュリティとコンプライアンス",
  安全防护策略: "安全保障政策",
  身份安全审计: "アイデンティティ・セキュリティ監査",
  密码管理: "パスワード管理",
  多因素安全认证策略: "多要素セキュリティ認証戦略",
  合规性: "コンプライアンス",
  加密传输与存储: "暗号化された伝送と保存",
  ISO质量体系认证: "ISO 品質システム認証",
  三级等级保护: "レベル3の保護",
  全生命周期安全保护: "完全なライフサイクルセキュリティ保護",
  员工A: "従業員 A",
  重要应用访问异常时: "アクセス例外を適用する際に",
  采取二次认证: "二次認証を受ける",
  员工B: "従業員 B",
  仅异地出差时: "オフサイト旅行時だけに",
  采取指纹认证: "指紋採取で認証する",
  员工C: "従業員 C",
  访问行为十分稳定: "訪問行動が安定している",
  日常免密登录: "パスワードレス ログイン",
  总监: "監督",
  业务敏感内容比较多: "ビジネスに影響を与えるコンテンツの増加",
  强密加定期转轮: "強力でレギュラーローター",
  经理: "管理人",
  少数业务系统: "マイノリティ業務システム",
  要求强密管理: "強力なパスワード管理を要求する",
  实习生: "インターンズ",
  访问权限有限: "限定的なアクセス",
  弱密可满足基本需求: "弱いパスワードは基本的な必要性を満たす",
  Authing解决方案: "Authing ソリューション",
  可视化安全审计: "ビジュアル セキュリティ監査",
  多因素登录: "マルチファクター登録",
  Authing合规: "Authing コンプライアンス",
  阅读报告: "レポートを読む",
};
